<template>
  <div>
    <div class="toolbar">
      <el-form :inline="true" :model="q" size="mini">
        <el-form-item label="处理时间">
          <el-date-picker
            v-model="q.time_range"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="pickerOptions"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="变动类型:">
          <el-select v-model="q.trans_type" clearable filterable placeholder="请选择">
            <el-option
              v-for="(item,key) of $store.state.app.transactionType_childAgency"
              :key="key"
              :label="item"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="danger" @click="reload">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <el-row type="flex" class="row-bg btn-row" justify="end">
            <el-button size="mini" @click="add" type="primary" icon="el-icon-plus">新增账号</el-button>
    </el-row>-->
    <el-table
      :data="listData.items"
      v-loading.body="listLoading"
      @sort-change="sortlist"
      size="mini"
      stripe
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="id" label="流水单号" width="150"></el-table-column>
      <el-table-column prop="trans_type" label="变动类型" width="150" :formatter="typeFormartter"></el-table-column>
      <el-table-column prop="amount" label="余额变动" width="150" :formatter="typeFormartter">
        <template slot-scope="scoped">
          <span
            :style="scoped.row.amount>=0?'color:green':'color:red'"
          >{{Number(scoped.row.amount)/100}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="当前余额" width="150" :formatter="typeFormartter"></el-table-column>
      <el-table-column prop="created_at" label="交易时间" sortable></el-table-column>
      <el-table-column prop="out_trans_no" label="关联订单号" sortable></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="q.page_no"
        :page-sizes="$store.state.app.pageSizeArr"
        :page-size="q.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getBalanceTrans } from "@/api";
import { useVcode } from "../../utils/CommonJs";
import { queryFilter } from "@/utils/patch";
import timedate from "@/utils/timedate.js";

export default {
  data() {
    return {
      listData: {},
      q: { page_size: 30, page_no: 1 },
      listLoading: false,
      show_id: null,
      resetPwdMeg: false,
      vcode: "",
      AgencyMainList: [], // 总代
      AgencyList: [], // 子代
      restInit: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateTodayHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateYesterdayHMS,
                timedate.dateYesterdayHMS
              ]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateWeekHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateOneMonthHMS,
                timedate.dateTodayHMS
              ]);
            }
          }
        ]
      }
    };
  },
  activated() {
    this.getList();
  },
  created() {},
  deactivated() {
    this.listLoading = false;
  },
  methods: {
    add() {
      if (this.resetPwdMeg) {
        this.resetPwdMeg.close();
      }
      this.show_id = null;
      this.showUpdate = true;
    },

    update(row) {
      if (this.resetPwdMeg) {
        this.resetPwdMeg.close();
      }
      this.show_id = row.id;
      this.showUpdate = true;
    },
    query() {
      this.q = { ...this.q, ...{ page_no: 1, page_size: 30 } };
      this.getList();
    },
    reload() {
      this.q = { page_size: 30, page_no: 1 };
      this.getList();
    },
    sortlist(sort) {
      this.q.$orderby = sort.prop;
      this.getList();
    },
    handleSizeChange(val) {
      this.q.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.q.page_no = val;
      this.getList();
    },
    getList() {
      if (this.resetPwdMeg) {
        this.resetPwdMeg.close();
      }
      for (let key in this.q) {
        if (this.q[key] === "") {
          delete this.q[key];
        }
      }
      const query = this.$dateFilter({
        data: this.q,
        range: "time_range",
        start: "created_at_begin",
        end: "created_at_end"
      });
      getBalanceTrans(queryFilter(query)).then(res => {
        if (res.status === 0) {
          this.listLoading = false;
          this.listData = res.data;
          this.listData.items = Array.from(res.data.items, x =>
            Object.assign({}, x, {
              warning_amount: Number(x.warning_amount) / 100
            })
          );
        }
      });
    },

    typeFormartter(row, column) {
      let columnName = column.property;
      if (columnName === "parent_nickname" && row.agency.agency_type == 2) {
        return row.agency.user_name;
      } else if (columnName === "trans_type") {
        return this.$store.state.app.agencyTransactionType[row.trans_type];
      } else if (columnName === "balance") {
        return Number(row.balance) / 100;
      }
    }
  }
};
</script>
